import React, { useState } from 'react';
export function FAQSection() {
  const faqs = [{
    q: 'How do I get the material?',
    a: "You'll receive a download link via email immediately after purchase. One click and the entire bundle is on your device. 100% digital PDF, no apps or extra platforms."
  }, {
    q: 'Can I use it on my phone during lessons?',
    a: 'Yes! High-contrast design for easy reading under the sun on any tablet or smartphone. Print it, project it, or pull it up courtside.'
  }, {
    q: 'Is it suitable for high-performance or just club players?',
    a: 'The blueprints cover the full spectrum, from beginners (2.0) to advanced competitive players (5.0), making it versatile for any coaching setting.'
  }, {
    q: 'Are the 6 bonuses included in every offer?',
    a: 'Yes. All 6 strategic bonuses are included with Tennis Ready at no extra cost.'
  }, {
    q: 'Can I scale the sessions for large groups?',
    a: 'Absolutely. The "3-6-10" Session Builder and the Large Group Matrix are built to keep 3, 6, or 10+ players active on one court.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-label="Frequently asked questions" className="bg-brand-dark py-32 px-4 border-t border-brand-border" data-id="element-65">
      <div className="max-w-4xl mx-auto" data-id="element-66">
        <h2 className="text-4xl md:text-5xl font-heading font-bold text-center text-white mb-16" data-id="element-67">
          ❓ FREQUENTLY ASKED{' '}
          <span className="text-brand-accent" data-id="element-68">QUESTIONS</span>
        </h2>
        <div className="space-y-4" data-id="element-69">
          {faqs.map((faq, i) => <div key={i} className="bg-brand-card rounded-2xl border border-brand-border overflow-hidden" data-id="element-70">
              <button className="w-full px-8 py-6 text-left flex justify-between items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-accent hover:bg-white/5 transition-colors" onClick={() => setOpenIndex(openIndex === i ? null : i)} aria-expanded={openIndex === i} data-id="element-71">
                <span className="font-bold text-white text-lg pr-8" data-id="element-72">
                  <span className="text-brand-accent mr-2" data-id="element-73">{i + 1} —</span>{' '}
                  {faq.q}
                </span>
                <span className={`text-brand-accent text-2xl flex-shrink-0 transition-transform duration-300 leading-none ${openIndex === i ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-74">
                  ▾
                </span>
              </button>
              {openIndex === i && <div role="region" data-id="element-75">
                  <div className="px-8 pb-8 text-white/80 border-t border-brand-border pt-6 text-lg leading-relaxed" data-id="element-76">
                    {faq.a}
                  </div>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}